export default [
  {
    path: '/package/zepeto',
    name: 'list-zepeto-package',
    component: () => import('@/views/zepeto/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      resource: 'zepeto',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/zepeto/create',
    name: 'create-zepeto-package',
    component: () => import('@/views/zepeto/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-zepeto-package',
      resource: 'zepeto',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-zepeto-package' },
        },
        {
          text: 'breadcrumb.createPackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/zepeto/:id/update',
    name: 'update-zepeto-package',
    component: () => import('@/views/zepeto/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-zepeto-package',
      resource: 'zepeto',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-zepeto-package' },
        },
        {
          text: 'breadcrumb.updatePackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/zepeto/:id',
    name: 'view-zepeto-package',
    component: () => import('@/views/zepeto/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-zepeto-package',
      resource: 'zepeto',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-zepeto-package' },
        },
        {
          text: 'breadcrumb.viewPackage',
          active: true,
        },
      ],
    },
  },
]
